module.exports = __webpack_public_path__ + "static/media/re-assignment.a1ee26d7.png";